window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
require('moment');
require('select2');
require('bootstrap');


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/vendor-dll-globals-fix.js
// module id = 4
// module chunks = 1